import React from 'react';
import PropTypes from 'prop-types';
import HotelOccupancyHOC from 'components/widgets/hotelOccupancyController';
import Lang from 'libraries/Lang';

const HotelOccupancyLarge = (props) => {
    const { showGuests, guests, rooms, tabKeyPress } = props;

    return (
        <>
            <label className="text-label">{Lang.trans('engine.rooms')} &amp; {Lang.trans('engine.guests')}</label>
            <button type="button" className="btn-guest w-100 text-left" onClick={showGuests} onKeyUp={tabKeyPress}>
                {rooms} {Lang.trans('engine.room')}(s), {guests} {Lang.trans('engine.guests')}
                <svg className="icon icon-btn" aria-hidden="true" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <use xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                </svg>
            </button>
        </>
    );
};

HotelOccupancyLarge.propTypes = {
    showGuests: PropTypes.func.isRequired,
    guests: PropTypes.number.isRequired,
    rooms: PropTypes.number.isRequired,
};

export default HotelOccupancyHOC(HotelOccupancyLarge);
